@if (!ongoingHysteroscopyExamination) {
  <div class="header-body">
    <mat-toolbar color="primary" class="" header>
      <img [src]="logo" class="header-logo" (click)="logoPress()" />
      <mat-toolbar class="navbar" fxLayout="row">
        <mat-button-toggle-group
          [(ngModel)]="activeButton"
          class="header-toolbar"
          >
          @for (menu of menuList; track menu) {
            <mat-button-toggle
              [value]="menu.path"
              routerLink="{{ menu.path }}"
              [routerLinkActive]="activeButton"
              [checked]="menu.path === activeButton"
              >{{ menu.name | translate }}</mat-button-toggle
              >
            }
          </mat-button-toggle-group>
        </mat-toolbar>
        <!--
        <input matInput placeholder="{{'Search' | translate}}..." class="header-search"> -->
        <div class="divider"></div>
        <button mat-fab class="header-notifications" (click)="openNotifications()">
          <mat-icon class="header-notifications-icon">notifications_none</mat-icon>
          @if (notifications.length > 0) {
            <span class="notification-badge">
              {{ notifications.length }}
            </span>
          }
        </button>
        <button mat-fab class="header-profile" [matMenuTriggerFor]="menu">
          <div class="header-profile-initials">{{ initials }}</div>
          <mat-menu #menu="matMenu">
            <app-logout />
          </mat-menu>
        </button>
        <!-- <button mat-fab class="header-profile" (click)="openProfile()">
        <div class="header-profile-initials">{{ initials }}</div>
      </button> -->
    </mat-toolbar>
  </div>
}

<!-- <nz-drawer
[nzClosable]="true"
[nzVisible]="profileVisible"
nzPlacement="right"
[nzTitle]="'Account' | translate"
(nzOnClose)="closeProfile()"
[nzWidth]="640"
>
<ng-container *nzDrawerContent>
  <div class="drawer-wrapper">
    <div class="drawer-top">
      <nz-descriptions [nzColumn]="2" nzTitle="Personal">
        <nz-descriptions-item nzTitle="Full Name" [nzSpan]="1"
          >{{ name }} {{ surname }}</nz-descriptions-item
          >
          <nz-descriptions-item nzTitle="Account" [nzSpan]="1"
            >-</nz-descriptions-item
            > -->
            <!-- <nz-descriptions-item nzTitle="City" [nzSpan]="1"
            >HangZhou</nz-descriptions-item
            >
            <nz-descriptions-item nzTitle="Country" [nzSpan]="1"
              >China🇨🇳</nz-descriptions-item
              >
              <nz-descriptions-item nzTitle="Birthday" [nzSpan]="1"
                >February 2,1900</nz-descriptions-item
                >
                <nz-descriptions-item nzTitle="Website" [nzSpan]="1"
                  >-</nz-descriptions-item
                  >
                  <nz-descriptions-item nzTitle="Message" [nzSpan]="2">
                    Make things as simple as possible but no simpler.
                  </nz-descriptions-item> -->
                <!-- </nz-descriptions>
                <nz-divider></nz-divider>
                <div class="language-row">
                  <label for="lang-select" class="lang-label">{{
                    "Language" | translate
                  }}</label>

                  <nz-select
                    id="lang-select"
                    [(ngModel)]="defaultLanguage"
                    (ngModelChange)="changeLanguage($event)"
                    class="lang-select"
                    [nzBorderless]="false"
                    [nzSize]="'default'"
                    [nzDropdownMatchSelectWidth]="false"
                    >
                    <nz-option
                      *ngFor="let lang of languageOptions"
                      [nzValue]="lang.value"
                      [nzLabel]="lang.label | translate"
                      >
                      <ng-template #nzLabel>
                        <span class="lang-option">
                          <img
                            [src]="lang.flag"
                            class="flag-icon"
                            alt="{{ lang.value }}"
                            />
                            {{ lang.label }}
                          </span>
                        </ng-template>
                      </nz-option>
                    </nz-select>
                  </div> -->

                  <!-- <div class="language-row">
                  <label for="lang-select" class="lang-label">{{
                    "Theme" | translate
                  }}</label>

                  <nz-select
                    id="lang-select"
                    [(ngModel)]="defaultTheme"
                    (ngModelChange)="changeTheme($event)"
                    class="lang-select"
                    [nzBorderless]="false"
                    [nzSize]="'default'"
                    [nzDropdownMatchSelectWidth]="false"
                    >
                    <nz-option
                      *ngFor="let theme of themeOptions"
                      [nzValue]="theme.value"
                      [nzLabel]="theme.label | translate"
                      >
                    </nz-option>
                  </nz-select>
                </div> -->

                <!-- <button
                mat-raised-button
                class="resetPassword"
                (click)="resetPassword()"
                >
                <mat-icon>vpn_key</mat-icon>
                {{ "Reset Password" | translate }}
              </button>
            </div>

            <div class="drawer-bottom">
              <button mat-raised-button class="logout" (click)="logout()">
                <mat-icon>exit_to_app</mat-icon>
                {{ "Logout" | translate }}
              </button>
            </div>
          </div>
        </ng-container>


      </nz-drawer> -->

      <nz-drawer
        [nzClosable]="true"
        [nzVisible]="notificationsVisible"
        nzPlacement="right"
        [nzTitle]="'Notifications' | translate"
        (nzOnClose)="closeNotifications()"
        [nzWidth]="400"
        >
        <ng-container *nzDrawerContent>
          <div class="notifications-wrapper">



            @if (notifications.length > 0) {
              @for (notification of notifications; track notification) {
                <div
                  class="notification-item"
                  >
                  <div class="notification-content">
                    <div class="notification-text">
                      <div class="notification-title">{{ notification.title }}</div>
                      <div class="notification-message">{{ notification.message }}</div>
                    </div>
                    <div class="notification-actions">
                      <button
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        (click)="viewNotification(notification)"
                        >
                        <i
                          nz-icon
                          nzType="eye"
                          nzTheme="outline"
                          nzStyle="font-size: 12px"
                        ></i>
                      </button>
                      <button
                        nz-button
                        nzType="text"
                        nzShape="circle"
                        (click)="deleteNotification(notification)"
                        >
                        <i
                          nz-icon
                          nzType="delete"
                          nzTheme="outline"
                          nzStyle="font-size: 12px"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <nz-divider></nz-divider>
                </div>
              }
            } @else {
              <div class="no-notifications">
                {{ "No notifications at the moment" | translate }}.
              </div>
            }
          </div>
        </ng-container>
      </nz-drawer>
